export default __webpack_public_path__ + "static/media/Arriva.f69f9fb1.webp";